(() => {
  if (customElements.get('fm-uniform-shop')) return;
  customElements.define('fm-uniform-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.grid = this.querySelector('[data-shop-grid]');
      this.cards = [...this.querySelectorAll('[data-shop-card]')];
      this.category = 'all';
      this.querySelectorAll('[data-shop-controls]').forEach(el => { el.hidden = false; });
      this.cards.forEach(card => {
        const gallery = card.querySelector('[data-shop-gallery]');
        const buttons = [...card.querySelectorAll('[data-shop-view]')];
        if (!gallery || buttons.length < 2) return;
        const stage = card.querySelector('.fm-shop__stage');
        const state = { selected: 0, hovering: false, frame: 0 };
        const sync = index => {
          buttons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.shopView) === index)));
          gallery.querySelectorAll('[data-shop-slide]').forEach((slide, i) => {
            slide.setAttribute('aria-hidden', String(i !== index));
            const link = slide.querySelector('a');
            if (link) link.tabIndex = i === index ? 0 : -1;
          });
        };
        const show = index => {
          gallery.scrollTo({ left: index * gallery.clientWidth, behavior: 'instant' });
          sync(index);
        };
        buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            state.selected = index;
            state.hovering = false;
            show(index);
          });
          button.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' || event.key === 'ArrowLeft' ? 0 : 1;
            state.selected = next;
            state.hovering = false;
            show(next);
            buttons[next].focus();
          });
        });
        gallery.addEventListener('scroll', () => {
          cancelAnimationFrame(state.frame);
          state.frame = requestAnimationFrame(() => {
            if (!gallery.clientWidth) return;
            const index = Math.max(0, Math.min(1, Math.round(gallery.scrollLeft / gallery.clientWidth)));
            sync(index);
            if (!state.hovering) state.selected = index;
          });
        }, { passive: true });
        stage.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          state.hovering = true;
          show(1);
        });
        stage.addEventListener('pointerleave', () => {
          if (!state.hovering) return;
          state.hovering = false;
          show(state.selected);
        });
        gallery.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch') state.hovering = false;
        }, { passive: true });
        sync(0);
      });
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-shop-filter]');
        if (!filter) return;
        this.category = filter.dataset.shopFilter;
        this.querySelectorAll('[data-shop-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
        this.update();
      });
      this.querySelector('[data-shop-sort]')?.addEventListener('change', () => this.update());
    }
    update() {
      const sort = this.querySelector('[data-shop-sort]').value;
      const ordered = [...this.cards].sort((a, b) => {
        if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price) || Number(a.dataset.order) - Number(b.dataset.order);
        if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price) || Number(a.dataset.order) - Number(b.dataset.order);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      ordered.forEach(card => {
        card.hidden = this.category !== 'all' && card.dataset.category !== this.category;
        this.grid.append(card);
      });
      this.querySelector('[data-shop-count]').textContent = ordered.filter(card => !card.hidden).length;
    }
  });
})();
